(() => {
  const initialize = (root) => {
    if (root.dataset.toraBundleInitialized === 'true') return;
    root.dataset.toraBundleInitialized = 'true';

    const form = root.querySelector('[data-tora-product-form] form');
    const mainSubmit = root.querySelector('[data-tora-main-submit]');
    const finalSubmit = root.querySelector('[data-tora-final-submit]');
    const availability = root.querySelector('[data-tora-availability]');
    const availabilityTitle = root.querySelector('[data-tora-availability-title]');
    const quantityInput = form?.querySelector('input[name="quantity"]');
    const isArabic = root.dataset.localeDirection === 'rtl';
    const isAvailable = root.dataset.bundleAvailable === 'true';

    if (availabilityTitle) {
      availabilityTitle.textContent = isAvailable
        ? (isArabic ? 'متوفرة حسب مخزون المكونات' : 'Available from component stock')
        : (isArabic ? 'نفدت الكمية' : 'Sold out');
    }

    availability?.classList.toggle('is-unavailable', !isAvailable);

    root.querySelectorAll('.torab__quantity-row .quantity__button').forEach((button) => {
      button.addEventListener('click', (event) => {
        if (!quantityInput) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (button.name === 'plus') quantityInput.stepUp();
        if (button.name === 'minus') quantityInput.stepDown();
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }, true);
    });

    if (finalSubmit) finalSubmit.disabled = !isAvailable;

    root.dispatchEvent(new CustomEvent('tora:bundle-viewed', {
      bubbles: true,
      detail: {
        productId: root.dataset.productId,
        handle: root.dataset.productHandle,
      },
    }));

    form?.addEventListener('submit', () => {
      root.dispatchEvent(new CustomEvent('tora:bundle-add-intent', {
        bubbles: true,
        detail: {
          productId: root.dataset.productId,
          handle: root.dataset.productHandle,
        },
      }));
    });
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.('[data-tora-product-bundle]')) initialize(scope);
    scope.querySelectorAll?.('[data-tora-product-bundle]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
